module.exports = __webpack_public_path__ + "static/peta-34f5ccdd8959ec86d4a0516cb38ec7d0.jpeg";